// import { getCookies } from '@/utils/cookies'
import Api from './API'
// import {getCookies} from '@/utils/cookies'

// const crypto = require('crypto')
function SystemSettingModel () {
  if (!(this instanceof SystemSettingModel)) {
    return new SystemSettingModel()
  }
}
// var authToken = localStorage.getItem('authToken')
// console.log(authToken, 'authToken')
// ++++++++++++++++++++++++++++ user login and user data api call start ++++++++++++++++++++++++++++
/*
* staff login api
*/
// SystemSettingModel.prototype.loginUser = async function (
//   email,
//   password,
//   crmId,
//   rememberMe,
//   callBackFunc,
//   onError
// ) {
//   var keyStr = 'CrmGB!m3@p!'
//   const algorithm = 'aes-256-cfb'
//   const hash = crypto.createHash('sha256')
//   hash.update(keyStr)
//   const keyBytes = hash.digest()
//   const iv = crypto.randomBytes(16)
//   const cipher = crypto.createCipheriv(algorithm, keyBytes, iv)
//   const enc = [iv, cipher.update(password, 'utf8')]
//   enc.push(cipher.final())
//   password = Buffer.concat(enc).toString('base64')
//   const data = {
//     email: email,
//     password: password,
//     platform: 'web',
//     crmId: crmId
//   }
//   console.log(data)
//   Api.login(data).then(data => {
//     if (data.success === 1) {
//       callBackFunc(data)
//     } else {
//       onError(data)
//     }
//   })
// }
/* ***** *********** ************* **************** ******************* ****************** ****
*
*                                             ME material Api
*
***** *********** ************* **************** ******************* ****************** **** */
SystemSettingModel.prototype.getGeneralData = async function (
  groupName,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('groupName', groupName)
  Api.getGeneralData(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

SystemSettingModel.prototype.updateSystemSetting = async function (
  optionsDetails,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('optionsDetails', JSON.stringify(optionsDetails))
  Api.updateSystemSetting(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
SystemSettingModel.prototype.updateCompanyLogo = async function (
  file,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('file', file)
  Api.updateCompanyLogo(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
export default SystemSettingModel



// WEBPACK FOOTER //
// ./src/View/SystemSetting/SystemSettingApi/SystemSettingModel.js